// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"snackbar__1MZUO"};


//////////////////
// WEBPACK FOOTER
// ./components/snackbar/style.scss
// module id = Ipdi
// module chunks = 9